export const branchLocation = [
    {
        "key": "11071081",
        "name": "DHANBAD"
    },
    {
        "key": "66031148",
        "name": "DIBRUGARH",
    },
    {
        "key": "11101121",
        "name": "HOWRAH",
    },
    {
        "key": "11141175",
        "name": "MALDA",
    },
    {
        "key": "11151309",
        "name": "NANDAKUMAR",
    },
    {
        "key": "ALL",
        "name": "All Locations"
    }, {
        "key": "HO",
        "name": "Head Office"
    },
    {
        "key": "MU",
        "name": "Mumbai"
    },
    {
        "key": "2",
        "name": "Mumbai - Andheri",
    },
    {
        "key": "3",
        "name": "PUNE - MOLEDINI ROAD",
    },
    {
        "key": "4",
        "name": "Delhi - ITO",
    },
    {
        "key": "5",
        "name": "CHENNAI - GOPALAPURAM",
    },
    {
        "key": "6",
        "name": "BANGALORE - INFANTRY ROAD",
    },
    {
        "key": "7",
        "name": "Kolkata - Kyd Street",
    },
    {
        "key": "9",
        "name": "Lucknow - Hazratganj",
    },
    {
        "key": "10",
        "name": "AHMEDABAD - NAVRANGPURA",
    },
    {
        "key": "13",
        "name": "CHANDIGARH - SECTOR 34",
    },
    {
        "key": "14",
        "name": "Vijaywada - Bandar Road",
    },
    {
        "key": "16",
        "name": "Kharagpur - Inda",
    },
    {
        "key": "17",
        "name": "Kolkata - GC Avenue",
    },
    {
        "key": "19",
        "name": "Calicut - Kannur Road",
    },
    {
        "key": "25",
        "name": "Gurgaon - Sector 39",
    },
    {
        "key": "26",
        "name": "Nasik - Canada Corner",
    },
    {
        "key": "28",
        "name": "VIZAG - WALTER WARD",
    },
    {
        "key": "29",
        "name": "Mumbai - Vashi",
    },
    {
        "key": "30",
        "name": "Amritsar - Ranjit Avenue",
    },
    {
        "key": "31",
        "name": "JALANDHAR - MULTANI TOWER",
    },
    {
        "key": "32",
        "name": "KOTTAYAM - CMS COLLEGE ROAD",
    },
    {
        "key": "33",
        "name": "NAGPUR - MOUNT ROAD",
    },
    {
        "key": "34",
        "name": "PATIALA - SERAWALA GATE",
    },
    {
        "key": "35",
        "name": "BHATINDA",
    },
    {
        "key": "39",
        "name": "Vellore - Krishna Nagar",
    },
    {
        "key": "41",
        "name": "TRIVANDRUM - PATTOM",
    },
    {
        "key": "45",
        "name": "Kollam - Sain Plaza",
    },
    {
        "key": "47",
        "name": "MYSORE - KUVEMPUNAGAR",
    },
    {
        "key": "48",
        "name": "THRISSUR - EAST FORT",
    },
    {
        "key": "49",
        "name": "Noida - Sector 18",
    },
    {
        "key": "51",
        "name": "Kannur - Payannur Road",
    },
    {
        "key": "52",
        "name": "Bhavnagar - Waghavadi Road",
    },
    {
        "key": "53",
        "name": "Mehasana - Wide Angle",
    },
    {
        "key": "56",
        "name": "Mangalore - Kadri",
    },
    {
        "key": "57",
        "name": "Aurangabad - Amarpreet Signal",
    },
    {
        "key": "59",
        "name": "Rajkot - Kalawad Road",
    },
    {
        "key": "61",
        "name": "Mumbai - Thane",
    },
    {
        "key": "62",
        "name": "MOGA",
    },
    {
        "key": "63",
        "name": "Cuttack - Link Road",
    },
    {
        "key": "64",
        "name": "Ranchi - Old Hazaribagh Road",
    },
    {
        "key": "66",
        "name": "Bhopal - MP Nagar",
    },
    {
        "key": "67",
        "name": "ROURKELA",
    },
    {
        "key": "68",
        "name": "Jamnagar - Amber Cinema Road",
    },
    {
        "key": "70",
        "name": "AGRA",
    },
    {
        "key": "71",
        "name": "VARANASI - LAXA ROAD",
    },
    {
        "key": "74",
        "name": "Delhi - Vasant Vihar",
    },
    {
        "key": "75",
        "name": "Trichy - Sea Horse Hospital",
    },
    {
        "key": "76",
        "name": "SALEM - PERAMANUR MAIN ROAD",
    },
    {
        "key": "77",
        "name": "Mumbai - Malad",
    },
    {
        "key": "80",
        "name": "Tirupati - Tilak Road",
    },
    {
        "key": "81",
        "name": "ALLAHABAD - COPER ROAD",
    },
    {
        "key": "83",
        "name": "Shimla - Mall Road",
    },
    {
        "key": "85",
        "name": "JABALPUR - NAPIER TOWN",
    },
    {
        "key": "86",
        "name": "Faridabad - Sector 16",
    },
    {
        "key": "87",
        "name": "Asansol - Rambandhu Talao",
    },
    {
        "key": "88",
        "name": "Dhanbad - Bank More",
    },
    {
        "key": "89",
        "name": "JAMMU - K.C PLAZA",
    },
    {
        "key": "91",
        "name": "Madurai - Bypass Road",
    },
    {
        "key": "93",
        "name": "Raipur - Pandri",
    },
    {
        "key": "94",
        "name": "Dehradun - Hathi Barkula",
    },
    {
        "key": "96",
        "name": "Bhilai - GE Road",
    },
    {
        "key": "97",
        "name": "NANDED - NIMBALKAR BUILDING"
    },
    {
        "key": "98",
        "name": "Haldwani - Durga City Centre",
    },
    {
        "key": "99",
        "name": "Gwalior - City Centre",
    },
    {
        "key": "100",
        "name": "Amravati - Rathi Nagar"
    },
    {
        "key": "101",
        "name": "Bareilly - Civil Lines",
    },
    {
        "key": "102",
        "name": "Ghaziabad - Raj Nagar",
    },
    {
        "key": "105",
        "name": "Solapur - Old Employment Sq",
    },
    {
        "key": "106",
        "name": "Meerut - Mangal Pandey Nagar",
    },
    {
        "key": "108",
        "name": "Kolhapur - Tara Bai Park",
    },
    {
        "key": "109",
        "name": "Roorkee - Dehradun Road",
    },
    {
        "key": "110",
        "name": "Sangli - Vishrambagh",
    },
    {
        "key": "112",
        "name": "BELGAUM - CIVIL HOSPITAL ROAD",
    },
    {
        "key": "113",
        "name": "UDAIPUR - SURAJPOLE",
    },
    {
        "key": "115",
        "name": "WARANGAL - HANAMKONDA",
    },
    {
        "key": "116",
        "name": "Aligarh - Ramghat Road",
    },
    {
        "key": "117",
        "name": "Ajmer - Vaishali Nagar",
    },
    {
        "key": "118",
        "name": "Gorakhpur - Bateya Hata Road",
    },
    {
        "key": "119",
        "name": "Goa - Panjim",
    },
    {
        "key": "120",
        "name": "Guntur - Arundalpet",
    },
    {
        "key": "121",
        "name": "Panipat - GT Road",
    },
    {
        "key": "123",
        "name": "Hazaribagh - Main Road",
    },
    {
        "key": "125",
        "name": "Ujjain - Freeganj",
    },
    {
        "key": "126",
        "name": "YAMUNANAGAR - URBAN ESTATE",
    },
    {
        "key": "129",
        "name": "Davanagere - Mandipet",
    },
    {
        "key": "132",
        "name": "Nellore - Magunta Layout",
    },
    {
        "key": "133",
        "name": "ROHTAK",
    },
    {
        "key": "138",
        "name": "Alappuzha - Sarada Complex",
    },
    {
        "key": "139",
        "name": "Ahmednagar - Sarjepura",
    },
    {
        "key": "140",
        "name": "Navsari - Sayaji Road",
    },
    {
        "key": "144",
        "name": "Bhilwara - SK Plaza",
    },
    {
        "key": "145",
        "name": "Junagadh - Moti Baug Road",
    },
    {
        "key": "146",
        "name": "Kurnool - C Camp Road",
    },
    {
        "key": "152",
        "name": "Karnal - Mughal Canal Market",
    },
    {
        "key": "158",
        "name": "Muzaffarpur - Zilla School",
    },
    {
        "key": "163",
        "name": "Sambalpur - Peer Baba Chowk",
    },
    {
        "key": "164",
        "name": "Nagercoil - Courts Road",
    },
    {
        "key": "167",
        "name": "Moradabad - Rastogi Complex"
    },
    {
        "key": "168",
        "name": "Silchar - Hospital Road",
    },
    {
        "key": "170",
        "name": "Udipi - Court Road",
    },
    {
        "key": "172",
        "name": "Karur - Kovai Road",
    },
    {
        "key": "176",
        "name": "PALLAKAD - T. B. ROAD",
    },
    {
        "key": "178",
        "name": "Lucknow - Gomtinagar",
    },
    {
        "key": "179",
        "name": "Kolkata - Kakurgachi",
    },
    {
        "key": "183",
        "name": "Bhubaneshwar - Baramunda",
    },
    {
        "key": "184",
        "name": "Vadodara - Karelibaug",
    },
    {
        "key": "193",
        "name": "Mumbai - Kalyan",
    },
    {
        "key": "195",
        "name": "Bangalore - Kalyan Nagar",
    },
    {
        "key": "202",
        "name": "Delhi - Pitampura",
    },
    {
        "key": "203",
        "name": "DELHI - OLD ISHWAR NAGAR",
    },
    {
        "key": "204",
        "name": "Mumbai - HO",
    },
    {
        "key": "206",
        "name": "Hyderabad - Banjara Hills",
    },
    {
        "key": "207",
        "name": "LUDHIANA - PAKKHOWAL ROAD (AG)",
    },
    {
        "key": "208",
        "name": "COCHIN - RAVIPURAM (AG)",
    },
    {
        "key": "209",
        "name": "Jamshedpur - Bistupur",
    },
    {
        "key": "210",
        "name": "COIMBATORE - D. B. ROAD (AG)",
    },
    {
        "key": "211",
        "name": "INDORE - RNT MARG (AG)",
    },
    {
        "key": "212",
        "name": "SURAT - RING ROAD (AG)",
    },
    {
        "key": "213",
        "name": "JAIPUR - MALVIYA MARG (AG)",
    },
    {
        "key": "214",
        "name": "KANPUR - THE MALL (AG)",
    },
    {
        "key": "215",
        "name": "HYDERABAD - SECUNDRABAD (AG)",
    },
    {
        "key": "216",
        "name": "Patna - Exhibition Road",
    },
    {
        "key": "217",
        "name": "Guwahati - GS Road",
    },
    {
        "key": "218",
        "name": "BURDWAN (AG)",
    },
    {
        "key": "227",
        "name": "Mumbai - Dadar",
    },
    {
        "key": "228",
        "name": "Pondicherry",
    },
    {
        "key": "229",
        "name": "Hubli",
    },
    {
        "key": "230",
        "name": "Erode",
    },
    {
        "key": "231",
        "name": "Nellore",
    },
    {
        "key": "232",
        "name": "Vapi",
    },
    {
        "key": "233",
        "name": "Siliguri",
    },
    {
        "key": "234",
        "name": "Bilaspur",
    },
    {
        "key": "235",
        "name": "Haridwar",
    },
    {
        "key": "236",
        "name": "Kota",
    },
    {
        "key": "237",
        "name": "Balasore",
    },
    {
        "key": "238",
        "name": "Chhapra",
    },
    {
        "key": "239",
        "name": "Arrah",
    },
    {
        "key": "240",
        "name": "MIRZAPUR",
    },
    {
        "key": "241",
        "name": "Hoshiarpur",
    },
    {
        "key": "242",
        "name": "MATHURA",
    },
    {
        "key": "243",
        "name": "ALWAR",
    },
    {
        "key": "244",
        "name": "REWA",
    },
    {
        "key": "245",
        "name": "AMBALA",
    },
    {
        "key": "246",
        "name": "GANDHIDHAM",
    },
    {
        "key": "247",
        "name": "DIBRUGARH",
    },
    {
        "key": "248",
        "name": "RAMGARH",
    },
    {
        "key": "249",
        "name": "LOHARDAGGA",
    },
    {
        "key": "250",
        "name": "PCMC PUNE",
    },
    {
        "key": "251",
        "name": "CHANDRAPUR",
    },
    {
        "key": "252",
        "name": "ANAND",
    },
    {
        "key": "253",
        "name": "CHINDWARA",
    },
    {
        "key": "254",
        "name": "RATLAM",
    },
    {
        "key": "255",
        "name": "FAIZABAD",
    },
    {
        "key": "256",
        "name": "JODHPUR",
    },
    {
        "key": "257",
        "name": "UNNAO",
    },
    {
        "key": "258",
        "name": "HAPUR",
    },
    {
        "key": "259",
        "name": "REWARI",
    },
    {
        "key": "260",
        "name": "ETAWAH",
    },
    {
        "key": "261",
        "name": "FIROZABAD",
    },
    {
        "key": "262",
        "name": "HARDOI",
    },
    {
        "key": "263",
        "name": "PATHANKOT",
    },
    {
        "key": "264",
        "name": "ELLURU",
    },
    {
        "key": "265",
        "name": "RAJAMUNDHRY",
    },
    {
        "key": "266",
        "name": "Chennai Adyar",
    },
    {
        "key": "267",
        "name": "LAKHIMPUR",
    },
    {
        "key": "268",
        "name": "GONDA",
    },
    {
        "key": "269",
        "name": "BIKANER",
    },
    {
        "key": "270",
        "name": "JAUNPUR",
    },
    {
        "key": "271",
        "name": "JHANSI",
    },
    {
        "key": "272",
        "name": "BHIWANI",
    },
    {
        "key": "273",
        "name": "DALTONGANJ",
    },
    {
        "key": "274",
    },
    {
        "key": "275",
        "name": "BHADRAK",
    },
    {
        "key": "276",
        "name": "SIWAN",
    },
    {
        "key": "277",
        "name": "ONGOLE",
    },
    {
        "key": "278",
        "name": "KARIMNAGAR",
    },
    {
        "key": "279",
        "name": "SHIVMOGA",
    },
    {
        "key": "280",
        "name": "KANNUR",
    },
    {
        "key": "281",
        "name": "THANJAVUR",
    },
    {
        "key": "282",
        "name": "TIRUNELVELI",
    },
    {
        "key": "283",
        "name": "CHENNAI VADAPALANI",
    },
    {
        "key": "284",
        "name": "GANDHINAGAR",
    },
    {
        "key": "285",
        "name": "MUMBAI KHAR",
    },
    {
        "key": "286",
        "name": "MUMBAI CHEMBUR",
    },
    {
        "key": "287",
        "name": "MUMBAI PANVEL",
    },
    {
        "key": "288",
        "name": "HOWRAH",
    },
    {
        "key": "289",
        "name": "PUNE DECCAN",
    },
    {
        "key": "290",
        "name": "Jayanagar Bangalore",
    },
    {
        "key": "291",
        "name": "CHENNAI ANNANAGAR"
    },
    {
        "key": "292",
        "name": "BANGALORE MALLESHWARAM",
    },
    {
        "key": "293",
        "name": "LUCKNOW ALIGANJ",
    },
    {
        "key": "294",
        "name": "DELHI DWARKA",
    },
    {
        "key": "66041259",
        "name": "AGARTALA",
    },
    {
        "key": "22011002",
        "name": "ALIGARH",
    },
    {
        "key": "22021004",
        "name": "ALLAHABAD",
    },
    {
        "key": "22051060",
        "name": "AMRITSAR",
    },
    {
        "key": "11081085",
        "name": "ASANSOL",
    },
    {
        "key": "11011010",
        "name": "BALASORE",
    },
    {
        "key": "22071155",
        "name": "BANDA"
    },
    {
        "key": "11161187",
        "name": "BARASAT"
    },
    {
        "key": "22041019",
        "name": "BAREILLY",
    },
    {
        "key": "22101031",
        "name": "BEGUSARAI"
    },
    {
        "key": "11021024",
        "name": "BERHAMPORE (WB)"
    },
    {
        "key": "22101032",
        "name": "BHAGALPUR"
    },
    {
        "key": "11041044",
        "name": "BHUBANESWAR",
    },
    {
        "key": "11241268",
        "name": "BIRPARA"
    },
    {
        "key": "66011055",
        "name": "BONGAIGAON"
    },
    {
        "key": "22041020",
        "name": "BUDAUN"
    },
    {
        "key": "11081087",
        "name": "BURDWAN",
    },
    {
        "key": "22141202",
        "name": "CHAKIA"
    },
    {
        "key": "22051061",
        "name": "CHANDIGARH",
    },
    {
        "key": "11151177",
        "name": "CONTAI"
    },
    {
        "key": "11241269",
        "name": "COOCHBEHAR"
    },
    {
        "key": "11041045",
        "name": "CUTTACK",
    },
    {
        "key": "22121073",
        "name": "DARBHANGA",
    },
    {
        "key": "22051306",
        "name": "DEHRADUN",
    },
    {
        "key": "11161191",
        "name": "DIAMOND HARBOUR",
    },
    {
        "key": "22131090",
        "name": "GAYA"
    },
    {
        "key": "22061098",
        "name": "GORAKHPUR",
    },
    {
        "key": "22081215",
        "name": "GURGAON",
    },
    {
        "key": "66021106",
        "name": "GUWAHATI",
    },
    {
        "key": "22151226",
        "name": "HAZIPUR"
    },
    {
        "key": "33021124",
        "name": "HYDERABAD"
    },
    {
        "key": "55011037",
        "name": "JABALPUR",
    },
    {
        "key": "44011137",
        "name": "JAIPUR",
    },
    {
        "key": "11111144",
        "name": "JAMSHEDPUR",
    },
    {
        "key": "22151227",
        "name": "JAMUI"
    },
    {
        "key": "22071157",
        "name": "KANPUR",
    },
    {
        "key": "11241273",
        "name": "KISHANGANJ"
    },
    {
        "key": "11131168",
        "name": "KRISHNAGAR"
    },
    {
        "key": "33021126",
        "name": "KURNOOL",
    },
    {
        "key": "22071158",
        "name": "LUCKNOW"
    },
    {
        "key": "22121075",
        "name": "MADHUBANI"
    },
    {
        "key": "22191308",
        "name": "RISHIKESH"
    },
    {
        "key": "33041300",
        "name": "VISAKHAPATNAM"
    },
    {
        "key": "22091289",
        "name": "VARANASI",
    },
    {
        "key": "11251282",
        "name": "SURI"
    },
    {
        "key": "22081220",
        "name": "SONIPAT"
    },
    {
        "key": "22141210",
        "name": "SIWAN",
    },
    {
        "key": "66031152",
        "name": "SIVASAGAR"
    },
    {
        "key": "11241274",
        "name": "SILIGURI",
    },
    {
        "key": "66041263",
        "name": "SILCHAR",
    },
    {
        "key": "22041023",
        "name": "SHAHJAHANPUR",
    },
    {
        "key": "55011041",
        "name": "SATNA"
    },
    {
        "key": "22121077",
        "name": "SAMASTIPUR"
    },
    {
        "key": "11201245",
        "name": "RANCHI",
    },
    {
        "key": "55021238",
        "name": "RAIPUR",
    },
    {
        "key": "22161233",
        "name": "PURNEA"
    },
    {
        "key": "11041048",
        "name": "PURI"
    },
    {
        "key": "22151229",
        "name": "PATNA",
    },
    {
        "key": "22051303",
        "name": "PANIPAT",
    },
    {
        "key": "22081217",
        "name": "NEW DELHI"
    },
    {
        "key": "66021112",
        "name": "NAOGAON"
    },
    {
        "key": "44021200",
        "name": "NAGPUR",
    },
    {
        "key": "11131169",
        "name": "NABADWIP"
    },
    {
        "key": "22141205",
        "name": "MUZAFFARPUR",
    },
    {
        "key": "44021199",
        "name": "MUMBAI"
    },
    {
        "key": "11161194",
        "name": "MOULALI"
    },
    {
        "key": "22121076",
        "name": "MOTIHARI",
    },
    {
        "key": "66021111",
        "name": "MORIGAON"
    },
    {
        "key": "11121164",
        "name": "MIDNAPUR"
    },
    {
        "key": "11151182",
        "name": "MECHEDA"
    },
    {
        "key": "66021110",
        "name": "MANGALDAI"
    },
    {
        "key": "307",
        "name": "KURUKSHETRA",
    },
    {
        "key": "335",
        "name": "GUMLA",
    },
    {
        "key": "345",
        "name": "HYDERABAD HIMAYATNAGAR LIBERTY",
    },
    {
        "key": "22",
        "name": "SURAT - RING ROAD (BT)",
    },
    {
        "key": "1",
        "name": "Hyderabad - Banjara Hills (BT)",
    },
    {
        "key": "11",
        "name": "LUDHIANA - PAKKHOWAL ROAD (BT)",
    },
    {
        "key": "12",
        "name": "COCHIN - RAVIPURAM (BT)",
    },
    {
        "key": "18",
        "name": "COIMBATORE - D. B. ROAD (BT)",
    },
    {
        "key": "21",
        "name": "INDORE - RNT MARG (BT)",
    },
    {
        "key": "24",
        "name": "JAIPUR - MALVIYA MARG (BT)",
    },
    {
        "key": "27",
        "name": "KANPUR - THE MALL (BT)",
    },
    {
        "key": "58",
        "name": "HYDERABAD - SECUNDRABAD (BT)",
    },
    {
        "key": "226",
        "name": "Mumbai HO Branch Office"
    },
    {
        "key": "295",
        "name": "ANANTAPUR",
    },
    {
        "key": "296",
        "name": "KAKINADA",
    },
    {
        "key": "297",
        "name": "NANDYAL",
    },
    {
        "key": "298",
        "name": "ADILABAD",
    },
    {
        "key": "299",
        "name": "MAHBUBNAGAR",
    },
    {
        "key": "300",
        "name": "NIZAMABAD",
    },
    {
        "key": "301",
        "name": "BASTI",
    },
    {
        "key": "302",
        "name": "BAGALKOT",
    },
    {
        "key": "303",
        "name": "BIJAPUR",
    },
    {
        "key": "304",
        "name": "GULBARGA",
    },
    {
        "key": "305",
        "name": "HASSAN",
    },
    {
        "key": "306",
        "name": "HOSPET",
    },
    {
        "key": "308",
        "name": "SAGAR",
    },
    {
        "key": "309",
        "name": "SATARA",
    },
    {
        "key": "310",
        "name": "TONK",
    },
    {
        "key": "311",
        "name": "MALDAH - ENGLISH BAZAR"
    },
    {
        "key": "312",
        "name": "CHITTOOR",
    },
    {
        "key": "313",
        "name": "BIHARSHARIF",
    },
    {
        "key": "314",
        "name": "NEYVELI",
    },
    {
        "key": "315",
        "name": "KANCHEEPURAM",
    },
    {
        "key": "316",
        "name": "DINDIGUL",
    },
    {
        "key": "317",
        "name": "SHAHJAHANPUR",
    },
    {
        "key": "318",
        "name": "BULANDSHAHR",
    },
    {
        "key": "319",
        "name": "ABOHAR",
    },
    {
        "key": "320",
        "name": "BAHADURGARH",
    },
    {
        "key": "321",
        "name": "MANDSAUR",
    },
    {
        "key": "322",
        "name": "WARDHA",
    },
    {
        "key": "323",
        "name": "GONDIA",
    },
    {
        "key": "324",
        "name": "BAHARAMPUR",
    },
    {
        "key": "325",
        "name": "AGARTALA",
    },
    {
        "key": "326",
        "name": "BARIPADA",
    },
    {
        "key": "327",
        "name": "BHARUCH",
    },
    {
        "key": "328",
        "name": "ICHALKARANJI",
    },
    {
        "key": "329",
        "name": "NADIAD",
    },
    {
        "key": "330",
        "name": "PALWAL",
    },
    {
        "key": "331",
        "name": "PILIBHIT",
    },
    {
        "key": "332",
        "name": "DURGAPUR"
    },
    {
        "key": "333",
        "name": "TIRUPPUR",
    },
    {
        "key": "334",
        "name": "CHITTAURGARH",
    },
    {
        "key": "336",
        "name": "RATNAGIRI",
    },
    {
        "key": "337",
        "name": "MOTIHARI",
    },
    {
        "key": "338",
        "name": "VALSAD",
    },
    {
        "key": "339",
        "name": "BARACKPUR"
    },
    {
        "key": "340",
        "name": "BHAGALPUR"
    },
    {
        "key": "341",
        "name": "BHARATPUR",
    },
    {
        "key": "342",
        "name": "BUXAR",
    },
    {
        "key": "343",
        "name": "DARBHANGA",
    },
    {
        "key": "344",
        "name": "FIROZPUR",
    },
    {
        "key": "92",
        "name": "Guwahati - GS Road (BT)",
    },
    {
        "key": "90",
        "name": "Patna - Exhibition Road (BT)",
    },
    {
        "key": "15",
        "name": "Jamshedpur - Bistupur (BT)",
    },
    {
        "key": "346",
        "name": "Borivali",
    }
]
